module.exports = __webpack_public_path__ + "static/media/img-1-fr.5b239428.webp";